import React from 'react';

import {
  Table,
  Popup,
  Menu,
  Header,
  Button,
  Icon,
  Pagination,
  Dropdown,
  Dimmer,
  Loader,
  Segment,
} from 'semantic-ui-react';

import { filterTypes } from './FilterTypeConfig';

import _ from 'lodash';
//import moment from 'moment'

import './QHGrid.css';

//import { DragDropContext } from 'react-dnd';
//import HTML5Backend from 'react-dnd-html5-backend';

const paginationOpts = [
  {
    text: '5',
    value: 5,
  },
  {
    text: '10',
    value: 10,
  },
  {
    text: '15',
    value: 15,
  },
  {
    text: '30',
    value: 30,
  },
  {
    text: '45',
    value: 45,
  },
  {
    text: '60',
    value: 60,
  },
  {
    text: '75',
    value: 75,
  },
  {
    text: '90',
    value: 90,
  },
];

/*
* Functions Parent Component Must Provide:
- handleGroupBy
- handleRemoveGroupBy
- handleGroupSortToggle
- handleSort
- handleColumnReorder
- handleColumnVisibilityToggle
- handleGeneralSearch
- handleResetFiltersToCustomView
- handleResetFiltersToDefaultView
- handleFiltersResetAll
- handlePageChange
- handleItemsPerPageChange

*Props Parent Must Pass:
- pageData
- columns
- grouping
- activePage
- generalSearch
- quickViews
- itemsPerPage
- sortBy
- sortOrder
*/
export class QHGrid extends React.Component {
  state = {
    colDraggingIndex: null,
    colHoverIndex: null,
  };

  setColDraggingIndex = (idx) => {
    this.setState({ colDraggingIndex: idx });
  };
  setColHoverIndex = (idx) => {
    this.setState({ colHoverIndex: idx });
  };

  //For Grouping
  onDrop = (evt) => {
    evt.preventDefault();
    const col = JSON.parse(evt.dataTransfer.getData('col'));
    if (!col.groupByDisabled) {
      const groupBy = this.props.handleGroupBy || function() {};
      groupBy(col);
    }
  };
  allowDrop = (evt) => {
    evt.preventDefault();
  };

  render() {
    const component = this;

    const columns = _.map(this.props.columns || [], (col, idx) => {
      col.QHgridIndex = idx;
      return col;
    });
    const visibleColumns = _.filter(columns, (col) => {
      return !col.hidden;
    });
    const numColumns = visibleColumns.length;
    const numRows = this.props.totalRows;

    const grouping = _.map(this.props.grouping || [], (group) => {
      return Object.assign({}, group, {
        field: (_.find(columns, (col) => {
          return col.ID === group.col_id;
        }) || {}).field,
        title: (_.find(columns, (col) => {
          return col.ID === group.col_id;
        }) || {}).title,
      });
    });

    const pageData = this.props.pageData;
    const activePage = this.props.activePage || 1;
    const itemsPerPage = this.props.itemsPerPage || 15;
    const numPages = this.props.totalPages || 0;

    const startIndex = (activePage - 1) * itemsPerPage;
    const endIndex = activePage * itemsPerPage > numRows ? numRows : activePage * itemsPerPage;

    const headers = _.map(visibleColumns, (col) => {
      const sortIcon =
        component.props.sortBy === col.field ? component.props.sortOrder === 'ascending' ? (
          <Icon name="long arrow alternate up" />
        ) : (
          <Icon name="long arrow alternate down" />
        ) : null;
      var sortProps = {
        //sorted: component.props.sortBy === col.field ? component.props.sortOrder : null,
        onClick: component.props.handleSort ? component.props.handleSort(col.field) : null,
      };
      var dragProps = {
        draggable: true,
        onDragStart: (evt) => {
          evt.dataTransfer.setData('col', JSON.stringify(col));
          component.setColDraggingIndex(col.QHgridIndex);
        },
        onDrop: (evt) => {
          evt.preventDefault();
          if (component.state.colDraggingIndex === col.QHgridIndex) {
            return;
          }

          const handleColumnReorder = component.props.handleColumnReorder
            ? component.props.handleColumnReorder
            : function() {};
          handleColumnReorder(component.state.colDraggingIndex, col.QHgridIndex);
        },
        onDragEnd: (evt) => {
          evt.preventDefault();
          component.setColDraggingIndex(null);
          component.setColHoverIndex(null);
        },
        onDragOver: (evt) => {
          evt.preventDefault();
        },
        onDragEnter: (evt) => {
          evt.preventDefault();
          //console.log('entered:' + idx)
          component.setColHoverIndex(col.QHgridIndex);
        },
        onDragLeave: (evt) => {
          evt.preventDefault();
          //console.log('left: ' + idx)
          if (component.state.colHoverIndex === col.QHgridIndex) {
            component.setColHoverIndex(null);
          }
        },
      };

      const leftHoverStyle = {
        borderLeft: '5px solid #1678C2',
        whiteSpace: 'nowrap',
      };
      const rightHoverStyle = {
        borderRight: '5px solid #1678C2',
        whiteSpace: 'nowrap',
      };

      var style = {
        whiteSpace: 'nowrap',
      };
      if (
        component.state.colDraggingIndex < component.state.colHoverIndex &&
        component.state.colHoverIndex === col.QHgridIndex
      ) {
        style = rightHoverStyle;
      } else if (
        component.state.colDraggingIndex > component.state.colHoverIndex &&
        component.state.colHoverIndex === col.QHgridIndex
      ) {
        style = leftHoverStyle;
      }

      if (col.sortDisabled) {
        sortProps = {};
      }

      const filteredIcon = (
        <Icon.Group>
          <Icon name="filter" color="blue" />
          <Icon corner name="asterisk" color="blue" />
        </Icon.Group>
      );
      const unfilteredIcon = <Icon name="filter" />;
      const filterType = _.get(col, 'filterable.type');
      const filterProps = _.get(col, 'filterable.props');
      const FilterDropdown = _.get(filterTypes, '[' + filterType + '].component');
      const filterVals = _.get(component.props, 'filters.' + col.field + '.value') || [];
      return (
        <Table.HeaderCell key={col.QHgridIndex} {...sortProps} {...dragProps} style={style} nowrap="true" collapsing>
          <span>
            {sortIcon}
            {!_.isUndefined(FilterDropdown) && (
              <FilterDropdown
                authorization={component.props.authorization || {}}
                selectedOpts={filterVals}
                onChange={component.props.handleFilterUpdate}
                trigger={filterVals.length > 0 ? filteredIcon : unfilteredIcon}
                filters={component.props.filters}
                filterType={filterType}
                {...filterProps}
              />
            )}
            {col.title}
          </span>
        </Table.HeaderCell>
      );
    });

    var prev_group_vals = [];
    const body = _.map(pageData, (item, idx) => {
      const cur_group_vals = _.map(grouping, (group) => {
        return _.isUndefined(item[group.field]) ? 'N/A' : item[group.field];
      });

      var group_header_row;
      //if the previous group values are different from the current item's group values, insert group by header row to indicate change in group values
      if (_.difference(cur_group_vals, prev_group_vals).length > 0) {
        group_header_row = _.map(grouping, (group, idx) => {
          return (
            <Table.Row key={idx}>
              {_.map(_.range(idx), (r_idx) => {
                return <Table.Cell style={{ backgroundColor: '#F2F2F2' }} key={r_idx} collapsing />;
              })}
              <Table.Cell
                colSpan={numColumns + grouping.length - idx}
                style={{ backgroundColor: '#F2F2F2' }}
                collapsing
              >
                <Icon name="caret down" />
                <strong>
                  {group.title}: {_.isUndefined(item[group.field]) ? 'N/A' : item[group.field]}
                </strong>
              </Table.Cell>
            </Table.Row>
          );
        });
      }
      //set this now for the next loop
      prev_group_vals = cur_group_vals;

      const rowLevelStyleCalcPrototype =
        this.props.rowLevelStyleCalc ||
        function() {
          return {};
        };
      const rowLevelStyle = rowLevelStyleCalcPrototype(item);
      return (
        <React.Fragment key={idx}>
          {group_header_row}
          <Table.Row style={rowLevelStyle}>
            {//Add placholder columns for grouping style
            _.map(grouping, (group, group_idx) => {
              return <Table.Cell style={{ backgroundColor: '#F2F2F2' }} key={group_idx} />;
            })}
            {_.map(visibleColumns, (col, col_idx) => {
              return (
                <Table.Cell key={col_idx}>
                  {_.isUndefined(col.template) && item[col.field]}
                  {!_.isUndefined(col.template) && col.template(item, component.props.additionalTemplateInfo)}
                </Table.Cell>
              );
            })}
          </Table.Row>
        </React.Fragment>
      );
    });

    const columnMenuItems = _.map(_.sortBy(columns, 'title'), (col, idx) => {
      const handleColumnVisibilityToggle = !_.isUndefined(component.props.handleColumnVisibilityToggle)
        ? component.props.handleColumnVisibilityToggle(col.ID)
        : function() {};

      return (
        <Dropdown.Item
          key={idx}
          onClick={(evt, data) => {
            evt.stopPropagation();
            handleColumnVisibilityToggle();
          }}
        >
          {!col.hidden && <Icon color="green" name="checkmark" />}
          {col.title}
        </Dropdown.Item>
      );
    });

    const groupMenuItems = _.map(grouping, (group, idx) => {
      const col =
        _.find(columns, (col) => {
          return col.ID === group.col_id;
        }) || {};
      const sortIcon =
        group.sortOrder === 'asc' ? <Icon name="long arrow alternate up" /> : <Icon name="long arrow alternate down" />;

      const handleRemoveGroupBy = !_.isUndefined(this.props.handleRemoveGroupBy)
        ? this.props.handleRemoveGroupBy(group.col_id)
        : function() {};
      const handleGroupSortToggle = !_.isUndefined(this.props.handleGroupSortToggle)
        ? this.props.handleGroupSortToggle(group.col_id)
        : function() {};
      return (
        <Button.Group key={idx} inverted size="mini" compact style={{ marginRight: '10px' }}>
          <Button inverted size="mini" compact onClick={handleGroupSortToggle}>
            {sortIcon}
            {col.title}
          </Button>
          <Button inverted size="mini" compact color="red" basic onClick={handleRemoveGroupBy}>
            X
          </Button>
        </Button.Group>
      );
    });

    const quickViewMenu = _.map(this.props.quickViews || [], (qv) => {
      return (
        <Menu.Item key={qv.name} onClick={this.props.handleShowQuickView(qv.view)}>
          {qv.name}
        </Menu.Item>
      );
    });

    return (
      <div style={{ width: '100%', margin: 0, padding: 0 }}>
        <Table
          striped
          sortable
          selectable
          celled
          compact="very"
          size="small"
          style={{ marginBottom: 0, paddingBottom: 0 }}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                colSpan={numColumns /*+ grouping.length*/}
                style={{ backgroundColor: '#071d49', color: 'white' }}
              >
                <Popup
                  trigger={
                    <Button inverted>
                      <Icon name="setting" />Customize
                    </Button>
                  }
                  position="bottom center"
                  on="click"
                >
                  <Header as="h3" dividing>
                    Customize
                  </Header>

                  <Menu vertical>
                    <Menu.Item onClick={this.props.saveCurrentSettings}>
                      {this.props.showSaveSettingsSuccessful && <Icon name="checkmark" color="green" />}
                      Remember Current Search
                    </Menu.Item>

                    <Menu.Item onClick={this.props.clearSavedSettings}>Clear Saved Settings</Menu.Item>
                  </Menu>
                </Popup>

                <Popup
                  trigger={
                    <Button inverted>
                      <Icon name="refresh" />Reset Filters
                    </Button>
                  }
                  position="bottom center"
                  on="click"
                >
                  <Header as="h3" dividing>
                    Reset Filters
                  </Header>

                  <Menu vertical>
                    <Menu.Item onClick={this.props.handleResetFiltersToCustomView}>Back To My Custom View</Menu.Item>

                    <Menu.Item onClick={this.props.handleResetFiltersToDefaultView}>Reset To Default View</Menu.Item>

                    {/*<Menu.Item onClick={this.props.handleFiltersResetAll}>Clear All Filters</Menu.Item>*/}
                  </Menu>
                </Popup>

                {quickViewMenu.length > 0 && (
                  <Popup
                    trigger={
                      <Button inverted>
                        <Icon name="lightning" />Quick Views
                      </Button>
                    }
                    position="bottom center"
                    on="click"
                  >
                    <Header as="h3" dividing>
                      Quick Views
                    </Header>
                    <Menu vertical>{quickViewMenu}</Menu>
                  </Popup>
                )}

                <Dropdown
                  scrolling
                  trigger={
                    <Button inverted>
                      <Icon name="columns" />Columns
                    </Button>
                  }
                  icon={null}
                >
                  <Dropdown.Menu>
                    <Dropdown.Header>Columns</Dropdown.Header>
                    <Dropdown.Divider />
                    {columnMenuItems}
                  </Dropdown.Menu>
                </Dropdown>
                {/* TODO: Determine whether or not Excel Export is a needed feature
                                !this.props.loading &&
                                (
                                    <Image 
                                        src={excel_logo}
                                        avatar 
                                        size='mini'
                                        onClick={this.exportExcel(columns, data)}
                                        style={{float: 'right', cursor: 'pointer'}}
                                    />
                                )
                            */}
              </Table.HeaderCell>
            </Table.Row>

            <Table.Row>
              <Table.HeaderCell
                colSpan={numColumns + grouping.length}
                style={{ backgroundColor: '#071d49', color: 'white', borderRadius: 0, borderTop: '2px solid white' }}
                onDrop={this.onDrop}
                onDragOver={this.allowDrop}
              >
                {groupMenuItems}
                Drag a column header and drop it here to group by that column
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
        </Table>

        <div style={{ margin: 0, padding: 0, width: '100%', height: '70vh', overflowX: 'auto', overflowY: 'auto' }}>
          <Table
            fixed={this.props.loading}
            striped
            sortable
            selectable
            celled
            compact="very"
            size="small"
            style={{ marginTop: 0, paddingTop: 0, borderRadius: 0, marginBottom: 0, paddingBottom: 0, fontSize: 12 }}
          >
            <Table.Header>
              <Table.Row>
                {_.map(grouping, (group, group_idx) => {
                  return <Table.HeaderCell key={group_idx} />;
                })}
                {headers}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {!this.props.loading && body}
              {this.props.loading && (
                <Table.Row>
                  <Table.Cell colSpan={numColumns /*+ grouping.length*/} style={{ padding: '0', margin: '0' }}>
                    <Segment style={{ height: '60vh' }}>
                      <Dimmer active>
                        <Loader>Loading Data</Loader>
                      </Dimmer>
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>

        {/*style={{marginTop: 0, paddingTop: 0, borderRadius: 0, borderTop: ".25px solid #DFDFDF"}}*/}
        <Table
          striped
          sortable
          selectable
          celled
          compact="very"
          size="small"
          style={{ marginTop: 0, paddingTop: 0, borderRadius: 0, borderTop: 0 }}
        >
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell
                colSpan={numColumns /*+ grouping.length*/}
                style={{ marginTop: 0, borderRadius: 0, borderTop: 0 }}
              >
                <Pagination
                  size="mini"
                  activePage={activePage}
                  totalPages={numPages}
                  onPageChange={this.props.handlePageChange}
                  firstItem={{ content: '«' }}
                  lastItem={{ content: '»' }}
                  nextItem={{ content: '⟩' }}
                  prevItem={{ content: '⟨' }}
                />

                <span>
                  <Dropdown
                    inline
                    options={paginationOpts}
                    value={itemsPerPage}
                    onChange={this.props.handleItemsPerPageChange}
                    style={{ marginLeft: '30px' }}
                  />
                  <strong>Items Per Page</strong>
                </span>

                <span style={{ float: 'right', color: '#BBBBBB', fontSize: 16 }}>
                  {startIndex + 1} - {endIndex} of {numRows} Items{' '}
                  <Button
                    style={{ marginLeft: 10 }}
                    circular
                    icon="undo"
                    size="mini"
                    color="blue"
                    onClick={this.props.reloadData}
                  />
                </span>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

export default QHGrid;



// WEBPACK FOOTER //
// ./src/Components/QHGrid.jsx